import { Grid, Stack } from "@mui/material";
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import TopSection from "../../../Components/Common/Top/TopSection";
import FGManageForecastMainContent from "./FGManageForecastMainContent";
import { FGBottlerSelectionProvider } from "../../../context/FGBottlerSelectionContext";
import { FGCustomBottlerSelectionProvider } from "../../../context/FGCustomBottlerSelectionContext";
import { setActiveDataElement } from "../../../redux/userSlice";

const FGManageForecast = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(setActiveDataElement("FG Inventory"));
  }, [dispatch]);

  return (
    <>
      <Stack>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <TopSection
              labelList={[
                { title: "Home", path: "/fg-manage-forecast" },
                { title: "Manage Forecast" },
              ]}
              title="Manage FG Inventory File"
            />
            <div className="container">
              <FGBottlerSelectionProvider>
                <FGCustomBottlerSelectionProvider>
                  <FGManageForecastMainContent></FGManageForecastMainContent>
                </FGCustomBottlerSelectionProvider>
              </FGBottlerSelectionProvider>
            </div>
          </Grid>
        </Grid>
      </Stack>
    </>
  );
};

export default FGManageForecast;
